
import { images } from '../constants';

import { FaPencilRuler, FaBox, FaHammer, FaCheckCircle, FaThumbsUp } from 'react-icons/fa';
import { FaMagnifyingGlass } from 'react-icons/fa6';


const process = [ 
    {
        id: 1,
        image: images.step1, // Image for Inspection
        icon: <FaMagnifyingGlass />, // Inspection icon
        title: 'Inspection',
        content: 'Our team conducts a thorough inspection of your roof to assess its condition and identify any issues.',
    },
    {
        id: 2,
        image: images.step2, // Image for Consultation & Design
        icon: <FaPencilRuler />, // Consultation & Design icon
        title: 'Consultation & Design',
        content: 'We consult with you to understand your roofing needs and preferences, followed by a tailored design solution.',
    },
    {
        id: 3,
        image: images.step3, // Image for Material Selection
        icon: <FaBox />, // Material Selection icon
        title: 'Material Selection',
        content: 'We assist you in selecting the best roofing materials that suit your budget and aesthetic preferences.',
    },
    {
        id: 4,
        image: images.step4, // Image for Installation
        icon: <FaHammer />, // Installation icon
        title: 'Installation',
        content: 'Our skilled team installs your new roof with precision, ensuring quality and durability in every step.',
    },
    {
        id: 5,
        image: images.step5, // Image for Quality Assurance
        icon: <FaCheckCircle />, // Quality Assurance icon
        title: 'Quality Assurance',
        content: 'We conduct a comprehensive quality check to ensure the installation meets our high standards and your expectations.',
    },
    {
        id: 6,
        image: images.step6, // Image for Client Satisfaction
        icon: <FaThumbsUp />, // Client Satisfaction icon
        title: 'Client Satisfaction',
        content: 'Your satisfaction is our priority. We ensure you\'re completely happy with the finished project before we consider it complete.',
    },
];

export default process;